import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class ExitChecklistService {
  headers;
  constructor(private http: HttpClient) {}

  getHeaders() {
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
      "access-token": localStorage.getItem("access-token"),
      client: localStorage.getItem("client"),
      clientid: localStorage.getItem('client_id'),
      expiry: localStorage.getItem("expiry"),
      uid: localStorage.getItem("uid"),
    });
  }

  createExitChecklist(value) {
    this.getHeaders();
    return this.http.post(
      environment.offboarding_url + "/exit_checklist_employee/",
      value,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getExitChecklist(id) {
    this.getHeaders();
    return this.http.get(
      environment.offboarding_url + "/exit-checklist/" + id,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  updateExitChecklist(value) {
    this.getHeaders();
    return this.http.put(
      environment.offboarding_url + "/exit-checklist/" + value.id,
      value,
      { headers: this.headers, observe: "response" }
    );
  }

  submitChecklistManager(data) {
    this.getHeaders();
    return this.http.post(
      environment.offboarding_url + '/exit_checklist_reporting_manager/',
      data,
      { headers: this.headers, observe: "response" }
    );
  }

  submitChecklistSysadmin(data) {
    this.getHeaders();
    return this.http.post(
      environment.offboarding_url + '/exit_checklist_system_admin/',
      data,
      { headers: this.headers, observe: "response" }
    );
  }

  submitChecklistHR(data) {
    this.getHeaders();
    return this.http.post(
      environment.offboarding_url + '/exit_checklist_hr/',
      data,
      { headers: this.headers, observe: "response" }
    );
  }

  submitChecklistEmp(data) {
    this.getHeaders();
    return this.http.post(
      environment.offboarding_url + '/exit_checklist_employee/',
      data,
      { headers: this.headers, observe: "response" }
    );
  }
  
  verifyChecklistEmployee(data) {
    this.getHeaders();
    return this.http.put(
      `${environment.offboarding_url}/verify_details/`,
      data,
      { headers: this.headers, observe: "response" }
    );
  }

  getAnswerExitChecklist(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_details/${id}?category=exit_checklist_reporting_manager`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getAnswerExitChecklistEmp(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_details/${id}?category=exit_checklist_employee`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getExitChecklistHR() {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/questions?category=exit_checklist_hr`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getAnswerExitChecklistHR(data) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_details/${data}?category=exit_checklist_hr`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getAllChecklists(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_checklist_all/`+id,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getAllChecklistsAns(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_checklist_all/`+id,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getReportManagerQuestions() {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/questions?category=exit_checklist_reporting_manager`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getSystemAdminAnswers(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_details/${id}?category=exit_checklist_system_admin`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getSystemAdminQuestions() {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/questions?category=exit_checklist_system_admin`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/exit-checklist.service.ts